<div ngbDropdown class="language-picker">
  <button class="btn btn-sm language dropdown-toggle form-control text-truncate default" id="dropdownMenu"
    ngbDropdownToggle [disabled]="disabled" type="button">
    {{ "Language."+displayvalue | translate }}
    <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
  </button>
  <div ngbDropdownMenu aria-labelledby="dropdownMenu">
    @for (langOption of languages; track langOption) {
      <button ngbDropdownItem value=langOption
      (click)="selectLanguage(langOption)" type="button">{{ "Language."+langOption | translate }}</button>
    }
  </div>
</div>